import axiosInstance from "./axiosConfig";
import { getUser } from "./authService";
const user =getUser();
export const getJobDescriptions = async (companyId: number, page: number, pageSize: number) => {
  try {
    const response = await axiosInstance.get(`/jobdescriptions/`, {
      params: { companyId,page, pageSize },
    });
    console.log("response",response)
    return response.data;

  } catch (error) {
    throw error;
  }
};

export const uploadJobDescription = async (formData: FormData) => {
  try {
    const response = await axiosInstance.post("/jobdescriptions/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteJobDescription = async (id: number) => {
  try {
    await axiosInstance.delete(`/jobdescriptions/${id}`);
  } catch (error) {
    throw error;
  }
};
export const downloadJobDescription = async (id: number) => {
  try {
    const response = await axiosInstance.get(`/jobdescriptions/download/${id}`, {
      responseType: "blob",
    });

    // ✅ Extract filename from Content-Disposition header
    const contentDisposition = response.headers["content-disposition"];
    let fileName = "downloaded_file"; // Default fallback

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+)"/);
      if (match) {
        fileName = match[1]; // Extract filename
      }
    }

    // ✅ Create the blob URL
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const url = window.URL.createObjectURL(blob);

    // ✅ Trigger file download with correct name
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName; // Use extracted filename
    document.body.appendChild(link);
    link.click();

    // ✅ Clean up
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
    
  } catch (error) {
    console.error("Failed to download file:", error);
  }
};

